import { combineReducers } from 'redux';
import inboxReducer from './inboxReducer';
import outboxReducer from './outboxReducer';
import draftReducer from './draftReducer';
import friendReducer from './friendReducer';
import friendRequestsReducer from './friendRequestsReducer';
import currentUserReducer from './currentUserReducer';
import notificationReducer from './notificationReducer';
import { RESET_STORE } from '../actions/types';

const appReducer = combineReducers({
  inbox: inboxReducer,
  outbox: outboxReducer,
  friends: friendReducer,
  friendRequests: friendRequestsReducer,
  draft: draftReducer,
  currentUser: currentUserReducer,
  notifications: notificationReducer,
});

const rootReducer = (state, action) => {
  // when a reset action is dispatched it will reset redux state
  if (action.type === RESET_STORE) {
    // eslint-disable-next-line no-param-reassign
    state = undefined;
  }
  // otherwise return app's top-level reducers
  return appReducer(state, action);
};

export default rootReducer;
